export const blogitem = [
    {
        image: "assets/img/portfolio/1.png",
        title: "Robotics and Automation",
        date: "09 Dec 2022",
        comment: "05 Comment",
        discription: "10 Must-know site amet width consectetur adipisicing elit. Illum ipsum eveniet harum eting Trends In 2023"

    },
    {
        image: "assets/img/portfolio/2.png",
        title: "AI and Creativity",
        date: "15 Mar 2023",
        comment: "10 Comment",
        discription: "10 Must-know site amet width consectetur adipisicing elit. Illum ipsum eveniet harum eting Trends In 2023"

    },
    {
        image: "assets/img/portfolio/3.png",
        title: "AI in Healthcare",
        date: "22 Apr 2023",
        comment: "05 Comment",
        discription: "10 Must-know site amet width consectetur adipisicing elit. Illum ipsum eveniet harum eting Trends In 2023"

    },
    {
        image: "assets/img/portfolio/4.png",
        title: "AI Ethics and Bias",
        date: "14 feb 2023",
        comment: "05 Comment",
        discription: "10 Must-know site amet width consectetur adipisicing elit. Illum ipsum eveniet harum eting Trends In 2023"

    },
]